import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCta } from './SectionCta';
import { withoutBlueprint, withBlueprint } from '../data/content';
export function BeforeAfterSection() {
  return <section className="w-full bg-navy py-16 sm:py-24" aria-label="Before and after" data-id="element-46" data-mp="ppn1x6u43xn2">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-47" data-mp="kuz9wxzwgl3q">
        <SectionHeading title={<>
              From random testing to a <span className="text-volt" data-id="element-49" data-mp="unetu0urbjr9">structured process</span>
            </>} data-id="element-48" data-mp="zl6upkddqg7l" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 md:gap-6" data-id="element-50" data-mp="18n6c4dsb3mb2">
          <div className="rounded-2xl border-2 border-alert/50 bg-ink p-5 sm:p-7" data-id="element-51" data-mp="18kae6pggkxmm">
            <p className="inline-flex rounded-md bg-alert px-3 py-1 font-display text-lg font-extrabold uppercase tracking-wider text-ink" data-id="element-52" data-mp="13lh0avx9f4lx">
              Before
            </p>
            <h3 className="mt-3 font-display text-3xl font-extrabold uppercase text-white" data-id="element-53" data-mp="35g83ah0uyzjm">
              Without the blueprint
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-54" data-mp="3bnmfo738nmb0">
              {withoutBlueprint.map(t => <li key={t} className="flex items-start gap-3 text-base font-medium text-white/90" data-id="element-55" data-mp="3bla2e78fe04a">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert/20" data-id="element-56" data-mp="3ldfpp3nqftd5">
                    <XIcon className="h-4 w-4 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-57" data-mp="3pfj3hyxvja1l" />
                  </span>
                  {t}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border-2 border-ok/60 bg-ink p-5 sm:p-7" data-id="element-58" data-mp="37ji4u5ube0e">
            <p className="inline-flex rounded-md bg-ok px-3 py-1 font-display text-lg font-extrabold uppercase tracking-wider text-ink" data-id="element-59" data-mp="86mdtnzxk7vp">
              After
            </p>
            <h3 className="mt-3 font-display text-3xl font-extrabold uppercase text-white" data-id="element-60" data-mp="25193tt1txq7x">
              With the blueprint
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-61" data-mp="21wrs6e17dta8">
              {withBlueprint.map(t => <li key={t} className="flex items-start gap-3 text-base font-semibold text-white" data-id="element-62" data-mp="1wz01fncaod7m">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-ok" data-id="element-63" data-mp="2bwa9sntn52z4">
                    <CheckIcon className="h-4 w-4 text-ink" strokeWidth={3.5} aria-hidden="true" data-id="element-64" data-mp="26wefjgaqwpwr" />
                  </span>
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg text-mist sm:text-xl" data-id="element-65" data-mp="2fwt4qqqtyp5j">
          The difference isn’t a magic diagnostic trick.{' '}
          <strong className="text-white" data-id="element-66" data-mp="2pnfguazc8xjh">It’s having a consistent process to follow.</strong>
        </p>

        <SectionCta label="Yes, I want the structured process" data-id="element-67" data-mp="33mf2d9rk0wbf" />
      </div>
    </section>;
}